module.exports = __webpack_public_path__ + "img/Airbnb-Landing-Page-1.0a47ad5a.jpg";